import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { IFinaliseSdBallotRequest } from '../../../shared/models/sd/sd-finalise-ballot-request';
import { SdBallotService } from '../../../shared/services/sd-ballot.service';


@Component({
    selector: 'app-sd-finalise-ballot-modal',
    templateUrl: './sd-finalise-ballot-modal.component.html',
    styleUrl: './sd-finalise-ballot-modal.component.scss',
    standalone: false
})
export class SdFinaliseBallotModalComponent implements OnDestroy{
  @Input() ballotId: number = 0;
  @Input() projectId: number = 0

  subscriptions: Subscription = new Subscription();

  sdFinaliseBallotForm: FormGroup = new FormGroup({
    confirmationCtrl: new FormControl(false, [Validators.requiredTrue]),
    finalCommentCtrl: new FormControl('', [Validators.required]),
  });

  constructor(
    public activeModal: NgbActiveModal,
    private _sdBallotService: SdBallotService,
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onFinaliseBallotClicked() {
    if(this.sdFinaliseBallotForm.invalid) {
      return;
    }

    let request: IFinaliseSdBallotRequest = {
      ballotId: this.ballotId,
      projectId: this.projectId,
      resolution: this.sdFinaliseBallotForm.get('finalCommentCtrl')?.value,
    };

    this.subscriptions.add(
      this._sdBallotService.finaliseSdBallot(request).subscribe({
        next: (response) => {
          if (response.success) {
            this.close(this.ballotId);
          } else {
            console.log(response.message);
            this.close();
          }
        },
        error: (error) => {
          console.log(error);
          this.close();
        },
      })
    );
  }

  close(ballotId: number | null = null): void {
    if (ballotId) {
      this.activeModal.close(ballotId);
    } else {
      this.activeModal.close();
    }
  }
}
